<div class="profile-address-input">
  <div class="current-address" *ngIf="currentAddressText" data-testid="profile-address-current">
    <span class="current-address-label">{{ "ProfileCurrentAddress" | translate }}</span>
    <span class="current-address-value">{{ currentAddressText }}</span>
    <span class="current-address-hint">{{ "ProfileCurrentAddressHint" | translate }}</span>
  </div>

  <app-question-world-address
    *ngFor="let question of questions"
    [question]="question"
    (changeAnswer)="onAnswerChange()"
    data-testid="profile-address-input"
  ></app-question-world-address>
</div>
